import React from "react";
import { Eye, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useTitanApp } from "@/hooks/useTitanApp";
import { setShowPreConsultImagePreviewModal } from "@/dispatchers/patientDispatchers";
export function PreConsultImagePreviewModal({}) {
  const handleDownload = () => {
    if (!preConsultImagePreview) return;
    const link = document.createElement("a");
    link.href = preConsultImagePreview;
    link.download = "PreConsult.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const { appState, patientState } = useTitanApp();
  const { showPreConsultImagePreviewModal, preConsultImagePreview } =
    patientState || {};
  const { darkMode } = appState;

  return (
    <Dialog
      open={showPreConsultImagePreviewModal}
      onOpenChange={() => setShowPreConsultImagePreviewModal(false)}
    >
      <DialogContent className="pres-modal max-w-4xl max-h-[170vh] p-0">
        <DialogHeader className="p-6 pb-4">
          <DialogTitle className="flex items-center gap-2">
            <Eye className="w-5 h-5 text-blue-600" />
            Image Preview
          </DialogTitle>
        </DialogHeader>
        <div className="px-6 pb-6">
          <div className="relative overflow-y-auto max-h-[75vh] custom-scrollbar">
            <img
              src={preConsultImagePreview || ""}
              alt="Prescription"
              className="w-full h-auto max-h-[170vh] object-contain rounded-lg border border-gray-200"
            />
            {/* <div className="mt-4 flex justify-end gap-2">
              <Button variant="outline" onClick={handleDownload}>
                <Download className="w-4 h-4 mr-2" />
                Download
              </Button>
              <Button
                variant="outline"
                onClick={() => setShowPreConsultImagePreviewModal(false)}
              >
                Close
              </Button>
            </div> */}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
